import { Tab, Text } from "@chakra-ui/react";

interface PageTabTitleProps {
  title: string;
  trackTabClickEvent?: () => void;
}
export const PageTabTitle = ({
  title,
  trackTabClickEvent,
}: PageTabTitleProps) => {
  return (
    <Tab
      outline="none"
      border="none"
      _focus={{
        outline: "none",
      }}
      _selected={{
        fontWeight: 700,
        color: "brand.primary",
        _dark: {
          color: "white",
        },
      }}
      fontWeight="700"
      fontSize="1.25rem"
      onClick={() => trackTabClickEvent && trackTabClickEvent()}
    >
      <Text fontSize="1.25rem">{title}</Text>
    </Tab>
  );
};
